// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Search_searchBar__Q41Jc","select":"Search_select__oza9R","submit":"Search_submit__dde5Y","hits":"Search_hits__KxWjV","name":"Search_name__xYv9L"};